import Helpers from "@/util/Helpers";

export default ({ instance, baseURL, headers}) => {
    const apiCalls = {        
        recuperarIntimacoesExibicao(filter){
            return instance({
                method: 'post',
                baseURL,
                url: 'Intimacoes/RecuperarIntimacoesExibicao',
                responseType: 'json',
                headers: headers,
                data: Helpers.aplicarValidacoes(filter),
            });
        },
        atualizarStatusLida(idIntimacao, idUsuarioAlteracao){
            return instance({
                method: 'post',
                baseURL,
                url: 'Intimacoes/AtualizarStatusLida',
                responseType: 'json',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSS-Protection': '1; mode=block',
                    'X-Content-Type-Options': 'nosniff',
                    'Content-Security-Policy': "script-src 'self' scripts.intimacao.kurierservicos.com.br; media-src 'self'; img src *; default-src 'self' https://*.intimacao.kurierservicos.com.br"
                  },
                data: Helpers.aplicarValidacoes({"idIntimacao":idIntimacao, "idUsuarioAlteracao":idUsuarioAlteracao}),
            });
        },
        exportarRelatorioIntimacoes(relatorio) {
            return instance({
                method: 'post',
                baseURL,
                url: 'Intimacoes/ExportarRelatorioIntimacoes',
                responseType: 'arraybuffer',
                headers: headers,
                data: Helpers.aplicarValidacoes(relatorio),
            });
        },
        controleIntimacoes(filtros){
            return instance({
                method: 'post',
                baseURL,
                url: 'Intimacoes/ControleIntimacoes',
                responseType: 'json',
                headers: headers,
                data: Helpers.aplicarValidacoes(filtros),
            });
        },
    }   
    return apiCalls;
}